// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
//import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

var jQuery = require('jquery');

// include jQuery in global and window scope (so you can access it globally)
// in your web browser, when you type $('.div'), it is actually refering to global.$('.div')
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

console.log(jQuery);


import '../js/bootstrap_js_files.js'
import '../js/jquery_nested_form.js'


Rails.start()
//Turbolinks.start()
ActiveStorage.start()

import '../js/bracket.js'
import '../js/best_in_place.js'
